import { useEffect, useState } from "react";
import { Grid2, Typography } from "@mui/material";
import Layout from "../Layout";
import GeneralHeader from "../../components/GeneralHeader";
import Footer from "../../components/Footer";
import { selectLoggedIn } from "../../store/userSlice/userSelectors";
import { getQueryObject } from "../../helpers/urlBuilder";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PAGE_LIST } from "../index";

import classes from './index.module.scss';
import { emailConfirmation } from "../../store/userSlice/userRequests";
import { addAlert } from "../../store/alertSlice/alertSlice";


const ConfirmationPage = () => {
  const [confirmed, setConfirmed] = useState(false);
  const isLoggedIn = useSelector(selectLoggedIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = getQueryObject();
  const confirmation = query.confirmation;

  useEffect(() => {
    if (isLoggedIn) {
      navigate(PAGE_LIST.CERTIFICATE);
    }

    if (!confirmation) {
      navigate(PAGE_LIST.LOGIN);
    } else {
      dispatch(emailConfirmation({ confirmation }))
        .then((action) => {
          const errorText = action?.payload?.message;

          if (errorText) {
            dispatch(addAlert({
              text: 'Code is invalid. Try login with your credentials in case you have already confirmed your email. Otherwise please contact our admin team',
              severity: 'error',
            }))
          } else {
            setConfirmed(true);
          }
        })
    }
  }, [isLoggedIn, confirmation]);

  return (
    <Layout
      header={<GeneralHeader />}
      center={(
        <Grid2
          container
          className={classes.container}
          direction="column"
          spacing={8}
        >
          {
            confirmed ? (
              <>
                <Grid2>
                  <Typography variant='h1'>Congratulations</Typography>
                </Grid2>
                <Grid2>
                  <Typography variant='body1'>Email confirmed successfully. You can sign in now</Typography>
                </Grid2>
              </>
            ) : null
          }

        </Grid2>
      )}
      footer={<Footer />}
    />
  )
}

export default ConfirmationPage;